import React, { useEffect, useState } from "react";
import InputText1 from "../components/InputText1";
import { adminServices } from "../services/AdminServices";
import Button2 from "../components/Button2";
import DataTable from "react-data-table-component";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import { ReactComponent as EmailIcon } from "../icons/email.svg";
import EmailRecipientsComponent from "../components/settings/EmailRecipientsComponent";
import { jwtDecode } from "jwt-decode";
import Dropdown from "../components/Dropdown";
const SettingsPage = () => {
  const [data, setData] = useState([]);
  const [padalaLimit, setPadalaLimit] = useState('');
  const [spendingLimit, setSpendingLimit] = useState('');
  const [spendingType, setSpendingType] = useState('');
  const [percentRate, setPercentRate] = useState('');
  const [serviceFee, setServiceFee] = useState('');
  const [posFee, setPosFee] = useState('');
  const [bucorFee, setBucorFee] = useState('');
  const [ecpayRate, setEcpayRate] = useState('');
  const [icarusAppRate, setIcarusAppRate] = useState('');
  const [pdlLoadRate, setPdlLoadRate] = useState('');
  const [merchantLoadRate, setMerchantLoadRate] = useState('');
  const [pdlToMerchantRate, setPdlToMerchantRate] = useState('');
  const [merchantToPdlRate, setMerchantToPdlRate] = useState('');
  const [status, setStatus] = useState('');
  const [columns, setColumns] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [showRecipients, setShowRecipients] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isBucorPadala, setIsBucorPadala] = useState(false);
  const [isBucorService, setIsBucorService] = useState(false);
  const [isBucorPOS, setIsBucorPOS] = useState(false);
  const limit = 20;
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    var token = localStorage.getItem("appToken");
    setIsAdmin(jwtDecode(token)["isAdmin"] === "1");
    getConfig();
    getPadala();
  }, []);
  useEffect(() => {
    if (offset) {
      getPadala();
    }
  }, [offset]);
  const handleCheckboxChange = setter => event => {
    setter(event.target.checked);
  };

  // setTimeout(() => {
  //     getConfig();
  //     getPadala();
  // }, 60000);

  const getConfig = async () => {
    var form = new FormData();
    form.append('params', '');
    try {
      const response = await adminServices.storeProcedure2("get_settings", {});
      const settingsData = response.data;
      setData(settingsData);
      setPadalaLimit(settingsData[0].padala_limit_per_month);
      setPercentRate(settingsData[0].percent_rate + '%');
      setServiceFee(settingsData[0].service_fee + '%');
      setPosFee(settingsData[0].pos_fee + '%');
      setBucorFee(settingsData[0].bucor_rate + '%');
      setEcpayRate(settingsData[0].ecpay_rate + '%');
      setIcarusAppRate(settingsData[0].icarus_app_rate + '%');
      setPdlLoadRate(settingsData[0].pdl_load_rate + '%');
      setMerchantLoadRate(settingsData[0].merchant_load_rate + '%');
      setPdlToMerchantRate(settingsData[0].pdl_to_merchant_rate + '%');
      setMerchantToPdlRate(settingsData[0].merchant_to_pdl_rate + '%');
      setStatus(settingsData[0].status);
      setSpendingType(settingsData[0].spending_type);
      setSpendingLimit(settingsData[0].spending_limit);
      setIsBucorPOS(settingsData[0].bucor_pf_enabled === "Yes");
      setIsBucorService(settingsData[0].bucor_sf_enabled === "Yes");
      setIsBucorPadala(settingsData[0].bucor_padala_enabled === "Yes");
    } catch (e) {
      //console.log(e);
      if (e.response.status === 401) {
        window.location.href = "/";
      }
    }
  };
  const handleResend = async id => {
    await adminServices.postData(`settings/resend/${id}`).then(r => {
      if (r.status === 200) {
        window.location.reload();
      }
    }).catch(error => {
      if (error.status == 401) {
        window.location.href = "/";
      }
    });
  };
  const getPadala = async () => {
    await adminServices.storeProcedure2('setting_request_list', {
      pLimit: limit,
      pOffset: offset
    }).then(r => {
      //setData(r.data);
      setFilteredData(prev => prev ? [...prev, ...r.data] : [...r.data]);
      var _col = [{
        name: 'Reference No',
        selector: data => data.ref_no.toUpperCase(),
        sortable: true,
        width: "200px"
      }, {
        name: 'User',
        selector: data => data.first_name + ' ' + data.last_name,
        sortable: true,
        width: "200px"
      }, {
        name: 'Description',
        selector: data => data.description,
        sortable: true,
        width: "450px"
      }, {
        name: 'Status',
        selector: data => data.status == 1 ? "Pending" : data.status == 2 ? "Approved" : "Declined",
        sortable: true
      },
      // { name: 'Date Requested', selector: data=>new Date(data.date_requested).toLocaleString(), sortable: true, width: "300px"},
      {
        name: 'Date Requested',
        width: '300px',
        sortable: true,
        cell: (data, index) => <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
                    <span>{new Date(data.date_requested).toLocaleString()}</span>
                    {data.status === 1 && index === 0 && <button onClick={() => handleResend(data.settings_request_id)} style={{
            marginLeft: '10px',
            padding: '4px 8px',
            fontSize: '0.8rem',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}>
                        Resend
                        </button>}
                    </div>
      }];
      setColumns(_col);
    });
  };
  if (localStorage.getItem('currentRole') != 1) {
    return <UnauthorizedComponent />;
  }
  return <div className="container">
        <EmailRecipientsComponent show={showRecipients} onClose={() => setShowRecipients(false)} />
        <div className="d-flex justify-content-between align-items-center mb-3">
            <h3>System Settings</h3>
            {isAdmin && <EmailIcon style={{
        width: '20px',
        height: '20px',
        marginRight: '10px',
        cursor: 'pointer'
      }} onClick={() => setShowRecipients(true)} />}
        </div>
       <form className="padalaForm">
             
            <InputText1 title={"Padala Amount Limit"} value={padalaLimit} placeholder={"0.00"} onChange={e => {
        setPadalaLimit(e.target.value.replace(/,/g, ''));
      }} onBlur={e => {
        if (padalaLimit == '') {
          setPadalaLimit('0.00');
        }
      }}>
            </InputText1>

            <InputText1 title={"Spending Limit"} value={spendingLimit} placeholder={"0.00"} onChange={e => {
        setSpendingLimit(e.target.value.replace(/,/g, ''));
      }} onBlur={e => {
        if (spendingLimit == '') {
          setSpendingLimit('0.00');
        }
      }}>
            </InputText1>

            <Dropdown title={"Spending Limit Duration"} data={[{
        value: "daily",
        label: "Daily"
      }, {
        value: "weekly",
        label: "Weekly"
      }, {
        value: "monthly",
        label: "Monthly"
      }, {
        value: "yearly",
        label: "Yearly"
      }]} onChange={e => setSpendingType(e.target.value)} value={spendingType} />

            {/* <InputText1 title={"Interest Rate%"}
             placeholder={"0%"}
             value={percentRate}
             onChange={(e)=>{ setPercentRate(e.target.value.replace('%','') + "%")}}
             onBlur={(e)=>{ if(percentRate.replace('%','') == '') { setPercentRate('0%') } }}
             style={{display: "none"}}>
             </InputText1> */}

            <InputText1 title={"Kiosk Fee%"} placeholder={"0%"} value={serviceFee} onChange={e => {
        setServiceFee(e.target.value.replace('%', '') + '%');
      }} onBlur={e => {
        if (serviceFee.replace('%', '') == '') {
          setServiceFee('0%');
        }
      }}>;
            
            </InputText1>

            <InputText1 title={"POS Fee%"} placeholder={"0%"} value={posFee} onChange={e => {
        setPosFee(e.target.value.replace('%', '') + '%');
      }} onBlur={e => {
        if (posFee.replace('%', '') == '') {
          setPosFee('0%');
        }
      }}>
            
            </InputText1>

            <InputText1 title={"Bucor Fee%"} placeholder={"0%"} value={bucorFee} onChange={e => {
        setBucorFee(e.target.value.replace('%', '') + "%");
      }} onBlur={e => {
        if (bucorFee.replace('%', '') == '') {
          setBucorFee('0%');
        }
      }}>
            </InputText1>

            <InputText1 title={"ECPay Rate%"} placeholder={"0%"} value={ecpayRate} onChange={e => {
        setEcpayRate(e.target.value.replace('%', '') + "%");
      }} onBlur={e => {
        if (ecpayRate.replace('%', '') == '') {
          setEcpayRate('0%');
        }
      }}>
            </InputText1>

            <InputText1 title={"Icarus App Rate%"} placeholder={"0%"} value={icarusAppRate} onChange={e => {
        setIcarusAppRate(e.target.value.replace('%', '') + "%");
      }} onBlur={e => {
        if (icarusAppRate.replace('%', '') == '') {
          setIcarusAppRate('0%');
        }
      }}>
            </InputText1>

            <InputText1 title={"PDL Load Rate%"} placeholder={"0%"} value={pdlLoadRate} onChange={e => {
        setPdlLoadRate(e.target.value.replace('%', '') + "%");
      }} onBlur={e => {
        if (pdlLoadRate.replace('%', '') == '') {
          setPdlLoadRate('0%');
        }
      }}>
            </InputText1>

            <InputText1 title={"Merchant Load Rate%"} placeholder={"0%"} value={merchantLoadRate} onChange={e => {
        setMerchantLoadRate(e.target.value.replace('%', '') + "%");
      }} onBlur={e => {
        if (merchantLoadRate.replace('%', '') == '') {
          setMerchantLoadRate('0%');
        }
      }}>
            </InputText1>

            <InputText1 title={"PDL to Merchant Rate%"} placeholder={"0%"} value={pdlToMerchantRate} onChange={e => {
        setPdlToMerchantRate(e.target.value.replace('%', '') + "%");
      }} onBlur={e => {
        if (pdlToMerchantRate.replace('%', '') == '') {
          setPdlToMerchantRate('0%');
        }
      }}>
            </InputText1>

            <InputText1 title={"Merchant to PDL Rate%"} placeholder={"0%"} value={merchantToPdlRate} onChange={e => {
        setMerchantToPdlRate(e.target.value.replace('%', '') + "%");
      }} onBlur={e => {
        if (merchantToPdlRate.replace('%', '') == '') {
          setMerchantToPdlRate('0%');
        }
      }}>
            </InputText1>

            <InputText1 title={"Status"} placeholder={""} value={status} onChange={e => {
        setStatus(e.target.value.replace('%', ''));
      }} readonly={true}>
            </InputText1>

            <div class=" w-50 bg-outline-light">
                <h6>Enable BuCor fee in:</h6>
                <div class="row mt-3">
                    <div class="col-md-4">
                    <div class="form-check">
                        <input checked={isBucorPadala} onChange={handleCheckboxChange(setIsBucorPadala)} class="form-check-input" type="checkbox" id="padalaCheckbox" />
                        <label class="form-check-label" for="padalaCheckbox">Padala</label>
                    </div>
                    </div>

                    <div class="col-md-4">
                    <div class="form-check">
                        <input checked={isBucorService} onChange={handleCheckboxChange(setIsBucorService)} class="form-check-input" type="checkbox" id="servicePurchasesCheckbox" />
                        <label class="form-check-label" for="servicePurchasesCheckbox">Service Purchases</label>
                    </div>
                    </div>

                    <div class="col-md-4">
                    <div class="form-check">
                        <input checked={isBucorPOS} onChange={handleCheckboxChange(setIsBucorPOS)} class="form-check-input" type="checkbox" id="posPurchasesCheckbox" />
                        <label class="form-check-label" for="posPurchasesCheckbox">POS Purchases</label>
                    </div>
                    </div>
                </div>
                </div>


       </form>
    
       {status != "Pending" && <Button2 text={"Submit"} onClick={async () => {
      const form = new FormData();
      form.append("padala_limit_per_month", padalaLimit);
      form.append("spending_limit", spendingLimit);
      form.append("spending_type", spendingType);
      form.append("percent_rate", percentRate.replace('%', ''));
      form.append("bucor_rate", bucorFee.replace('%', ''));
      form.append("service_fee", serviceFee.replace('%', ''));
      form.append("pos_fee", posFee.replace('%', ''));
      form.append("ecpay_rate", ecpayRate.replace('%', ''));
      form.append("icarus_app_rate", icarusAppRate.replace('%', ''));
      form.append("pdl_load_rate", pdlLoadRate.replace('%', ''));
      form.append("merchant_load_rate", merchantLoadRate.replace('%', ''));
      form.append("pdl_to_merchant_rate", pdlToMerchantRate.replace('%', ''));
      form.append("merchant_to_pdl_rate", merchantToPdlRate.replace('%', ''));
      form.append("bucor_padala_enabled", isBucorPadala ? "Yes" : "No");
      form.append("bucor_sf_enabled", isBucorService ? "Yes" : "No");
      form.append("bucor_pf_enabled", isBucorPOS ? "Yes" : "No");
      await adminServices.submitConfig(form).then(r => {
        if (r.status == 204) {
          window.location.href = "/settings";
        }
      }).catch(e => {
        alert("Error occured");
      });
    }} style={{
      width: "200px",
      backgroundColor: "#61dd48"
    }} />}

        <div className="d-flex justify-content-between align-items-center">
            <h3>Historical Requests</h3>
            <a href="javascript:void(0);" onClick={() => {
        setOffset(prev => prev + limit);
      }}>Load More</a>
        </div>
        <DataTable columns={columns} data={filteredData} pagination={false} highlightOnHover style={{
      zIndex: 0
    }} />
    </div>;
};
export default SettingsPage;